<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="closePopup()"></div>
    <div class="popup popup--idea-similar">
      <button class="popup-close" @click="closePopup()"></button>
      <span class="popup-title">Similar ideas:</span>
      <div class="popup-box">
        <a class="link-icon"><span>Boxes for New Joiners</span> <i class="icon-arrow"></i></a>
        <div class="box-user">
          <div class="box-user-img">
            <img src="../../../assets/images/pic-person.jpg">
          </div>
          <span>John Griffin + 3 more people</span>
        </div>
      </div>
      <div class="popup-box">
        <a class="link-icon"><span>Welcome packs for everyone</span> <i class="icon-arrow"></i></a>
        <div class="box-user">
          <div class="box-user-img">
            <img src="../../../assets/images/pic-person.jpg">
          </div>
          <span>Jurrien Oldhof</span>
        </div>
      </div>
      <div class="popup-box">
        <a class="link-icon"><span>Welcome boxes for New Joiners</span> <i class="icon-arrow"></i></a>
        <div class="box-user">
          <div class="box-user-img">
            <img src="../../../assets/images/pic-person.jpg">
          </div>
          <span>Ava Gregoraci</span>
        </div>
      </div>
      <div class="form-bottom">
        <button class="link" @click="closePopup()"><span>Back to edit</span></button>
        <span class="span-icon"><span>Saved as draft (Dec 8, 2020; 11:43)</span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimilarIdeasPopup",
  methods: {
    closePopup(){
      this.$emit('closePopup')
    }
  }
}
</script>

<style scoped>

</style>